import React from "react";
import ReactJson from "react-json-view";

const ReactJsonViewer = ({ style = {}, src = {}, height = "200px", collapsed = true }) => {
    return (
        <div style={{ ...style, height: "100%", overflow: "auto", maxHeight: height }}>
            <ReactJson src={src} collapsed={collapsed} />
        </div>
    )
}

export default ReactJsonViewer;